import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

function Career() {
   const location = useLocation();
    
      // Scroll to the section if specified in the URL state
      useEffect(() => {
        if (location.state?.scrollTo) {
          const element = document.getElementById(location.state.scrollTo);
          if (element) {
            // Use smooth scrolling to the section
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [location]);
    return (
        <div>
                <div  className='ibdp-hero-sec'>
            <img src='newimg/infa5.webp'/>
    
          </div>
        <div className="career-sec">
            <div className="career-left-sec">
          <div className="tab-fixed-scroll">
            <div className="qucik-links ">

            <div className='cam-lower-sec'>  
      <h1 className='title'>Quick Links</h1>
      </div>
      <Link to="/events"> <div className="qucik-img-link">
                  
                       Image Gallery
                    </div>
                    </Link>
                   
                    <Link to="/videos"> <div className="qucik-img-link">

                   School Video
                 
                    </div></Link>
                    <Link to="/admission"><div className="qucik-img-link">
                   Admission
                
                    </div>
                    </Link>
                </div>

              
                <div className='school-detail-box'>
            <h1>Sanskar School</h1>
            <h5>The Revival of Tradition</h5>
            <ul>
              <li>117-121, Vishwamitra Marg, Hanuman Nagar Ext., Sirsi Road, Jaipur - 302012</li>
              <li>info@sanskarjaipur.com</li>
              <li> +91-0141-2246189 / +91-0141-2357844 / +91-0141-2245602</li>

            </ul>



            </div>
          </div>
                
        
            </div>
            <div className="career-right-sec">
                {/* <div className="sports-img">
                    <img src="../newimg/competitive.webp" alt="" />

                </div> */}

                
<div className='cam-lower-sec'>
         <h1 className='title'>Working with Sanskar</h1>
      </div>
      <p>At Sanskar School, the safety and well-being of our students is our paramount concern. We are committed to creating a safe and nurturing environment for all, and we expect all staff members to share this commitment. As part of our rigorous recruitment process, all candidates will be required to undergo thorough child protection screenings. These include but are not limited to-background verification, including criminal record checks and checks against relevant databases, reference checks, and behavioral assessments relevant to the role. Any adverse findings in these screenings will result in disqualification from consideration.</p>

  
      <br/>
      <br/>
      <div className='cam-lower-sec'>
      <h1 className='title'>We Require</h1>
</div>
      <p>At Sanskar School Jaipur, we are committed to prepare distinguished individuals with feelings, sensibilities, responsibility and compassion to live in today's world.. We foster an innovative and dynamic learning environment, which includes international mindedness project- based learning, access to state-of-the-art technology, and a focus on collaborative and independent learning, supported by a team of dedicated educators and administrators. While professional training is valuable, we believe that exceptional teachers possess a natural talent for engaging students, coupled with strong pedagogical skills and a commitment to continuous professional development. We are particularly interested in educators who are adept at facilitating student-centered learning and creating engaging, interactive learning experiences. We offer a supportive work environment, opportunities for professional growth, and a competitive compensation package.</p>

  
      <br />
      <br />
    
      <div className='cam-lower-sec'>    
      <h1 className='title'>We Offer</h1>
      </div>
      
      <p>At Sanskar School, we value our employees and are committed to providing a comprehensive and competitive total rewards package that supports their overall well-being. We strongly believe to invest in our people and provide opportunities designed to help our employees thrive both personally and professionally.</p>
      <p>We offer a supportive and rewarding work environment, along with a comprehensive benefits package designed to attract and retain top talent.</p>
      <p><b> At Sanskar we care about our employees. Join our team and experience the Sanskar School difference.</b></p>
      <br />
      <br />
      <div className='cam-lower-sec'>  
      <h1 className='title'>Opportunities</h1>
      </div>

      <p>At Sanskar School, we believe that a great school is built by great educators and professionals. We are committed to providing an enriching and collaborative environment where passionate individuals can make a lasting impact on young minds. Whether you are an experienced educator or an enthusiastic professional looking to contribute to the world of education, we invite you to explore opportunities with us.</p>
      <br/>
      <br/>
      
      <div className='cam-lower-sec'>  
      <h1 className='title'>Join us for:</h1>
      <ul>
        <li>A dynamic and inclusive work culture that fosters innovation and growth.</li>
        <li>Opportunities for continuous professional development through training, workshops, and certifications.</li>
        <li>Competitive salary packages and benefits.</li>
        <li>Access to state-of-the-art facilities and resources for effective teaching and learning.</li>
        <li>A supportive community that values work-life balance and staff well-being.</li>
      </ul>
      <p><b>Positions Available:</b></p>
      <p><b>Teaching Positions:</b></p>
      <ul className="join-us post-name">
        <li>Primary Teacher</li>
        <li>Secondary Teacher</li>
        <li>Special Education Teacher</li>
        <li>Language Teacher (ESL, French, Spanish, etc.)</li>
        <li>Physical Education (PE) Teacher</li>
        <li>Music/Dance/Art Teacher</li>
        <li>Computer/IT Teacher</li>
       
      </ul>

      <p><b>Other Roles:</b></p>
      <ul className="join-us post-name post-name">
        <li>Academic & Non-Academic Staff</li>
        <li>Administration & Operations Staff</li>
        <li>Student Support & Well-being</li>
        </ul>
      </div>

      {/* <div className='cam-lower-sec'>  
      <h1 className='title'>Applicants should:</h1>
      </div>

      <ul className="careers-list">
        <li>Should have an English-medium educational background.</li>
        <li>Must have experience and confidence in working within an internationally focused environment.</li>
        <li>Should be capable of creating a supportive and engaging learning atmosphere.</li>
        <li>Must be skilled in challenging and nurturing students using varied instructional strategies tailored to their needs.</li>
        <li>Should be able to design a learning program that aligns with students' backgrounds, interests, perspectives, and individual requirements.</li>
        <li>Must be dedicated to ongoing professional development and lifelong learning.</li>
      </ul> */}
<br />
<br />
<div className='cam-lower-sec'> 
<h1 className='title'>How to Apply?</h1>
</div>
<p>
If you are interested in joining our team, please submit your application by: Email: <a href="mailto:info@sanskarjaipur.com">info@sanskarjaipur.com </a>  
</p>
      <p>Only shortlisted candidates will be contacted further.</p>
      <p>We thank you for your interest in our school.</p>



            </div>
        </div>
        </div>
      )
    }

    export default Career;
